import { all, takeEvery, put, call } from "redux-saga/effects";
import { push } from "connected-react-router";
import { encrypt } from "common/helpers/crypt";
import { redirect } from "common/helpers/location";
import { MAIN_PAGE } from "common/enums/app";
import { notification } from "components/ui";
import * as loginDataContext from "common/dataProvider/login";
import * as userDataContext from "common/dataProvider/user";

import * as action from "../actions/authAction";

export function* sendSignInSaga({ payload }) {
	try {
		const { email, password } = payload;

		// генерируем токен из почты и пароля
		let token = "";
		try {
			token = encrypt(email, password);
		} catch (err) {
			throw { status: 401 };
		}

		yield call(loginDataContext.postLogin, token);
		yield put(action.sendSignIn.success());

		redirect(MAIN_PAGE);
	} catch (e) {
		yield put(action.sendSignIn.error());
	}
}

export function* sendForgotSaga({ payload }) {
	try {
		const { email } = payload;

		yield call(userDataContext.postUserPasswordRestore, { email });

		yield put(action.sendForgot.success());
		yield put(push(`/sign-in`));

		notification.success("Смена пароля", "Запрос успешно отправлен. Проверьте электронную почту.");
	} catch (e) {
		yield put(action.sendForgot.error());
	}
}

export default function*() {
	yield all([
		takeEvery(action.sendSignIn.request, sendSignInSaga),
		takeEvery(action.sendForgot.request, sendForgotSaga)
	]);
}
